import { EventCreatorMap } from '@app/analytics/models/helpers';

// import footerClick from './footer-click';
import headerClick from './header-click';
// import navbarClick from './navbar-click';
// import promoClick from './promo-click';

import * as HeaderActions from '@app/core/header/store/actions/header.action';

const eventsMap: EventCreatorMap = {
  [HeaderActions.CLICK_ON_HEADER_BUTTON]: headerClick
};

export default eventsMap;
